import { Role, ICurrentUser, BMTableBuilding } from '@api'
import { IPermissionsOnBuilding } from './types'

function canLocationAdminManageBuilding(user: ICurrentUser, building: BMTableBuilding | null) {
  if (!building) return false

  return building?.floors?.every((f) =>
    user.employee.locationAdmins.find(({ floorPlan }) => f.id === floorPlan.id)
  )
}

export function onBuilding(
  user: ICurrentUser,
  building: BMTableBuilding | null
): IPermissionsOnBuilding {
  const permissions = {
    canCreateFloor: true,
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canHide: true,
  }

  if (
    user.isSuperUser ||
    user.employee.role === Role.ADMIN ||
    user.employee.role === Role.POWER_ADMIN
  )
    return permissions

  if (user.employee.role === Role.LOCATION_ADMIN) {
    const canManage = canLocationAdminManageBuilding(user, building)

    return {
      ...permissions,
      canCreate: false,
      canDelete: false,
      canUpdate: canManage,
      canHide: canManage,
      canCreateFloor: false,
    }
  }

  return {
    canCreate: false,
    canUpdate: false,
    canDelete: false,
    canHide: false,
    canCreateFloor: false,
  }
}
